import { render } from "./OrdersCard.vue?vue&type=template&id=21c8525b"
import script from "./OrdersCard.vue?vue&type=script&lang=js"
export * from "./OrdersCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__